module.exports = __webpack_public_path__ + "c1614ab367a115d2bdec1aa078a131ac.png";